import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458164b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "mlsImport",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalBody = _resolveComponent("ModalBody")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("iframe", {
              id: "mlsMapper",
              src: _ctx.url,
              width: "100%",
              frameBorder: "0"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}